$('.faq').on('click', function (e) {
    e.preventDefault();

    const $this = $(this);
    const $chevron = $this.find('.faq__chevron');
    const $question = $this.find('.faq__question');
    const $answer = $this.find('.faq__answer');

    if ($chevron.length > 0 && $question.length > 0) {
        const isAnswerVisible = $answer.is(':visible');

        $chevron.toggleClass('active', !isAnswerVisible);
        $question.toggleClass('active', !isAnswerVisible);

        if (isAnswerVisible) {
            $answer.slideUp();
        } else {
            $answer.slideDown();
        }
    }
});
